import { createContext, useContext, useState } from 'react';

const SavingContext = createContext();

export const SavingProvider = ({ children }) => {
    const [isSaving, setIsSaving] = useState(false);
    return (
        <SavingContext.Provider value={{ isSaving, setIsSaving }}>
            {children}
        </SavingContext.Provider>
    );
};

export const useSaving = () => useContext(SavingContext);
